import { Injectable, Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe regarding the translation months by number to a string.
 * requires an import in the decorator.
 * usage only inside the html template. NO TS CODE.
 * for ts code useage @see MonthToStringService
 */
@Pipe({
  name: 'monthToStringPipe',
  standalone: true
})
export class MonthToStringPipe implements PipeTransform {

  public transform(month: number): string {
    return MonthToStringService.transform(month);
  }

}

/**
 * Pipe regarding the translation months by number to a string.
 * no import required.
 * no instance required.
 * usage only inside the ts code. NO HTML TEMPLATE.
 * for html template usage @see MonthToStringPipe
 */
@Injectable({
  providedIn: 'root'
})
export class MonthToStringService {

  public static transform(month: number): string {
    let monthString: string = '';
    switch (month) {
      case 0: {
        monthString = $localize`:@@MonthJanuary:January`;
        break;
      }
      case 1: {
        monthString = $localize`:@@MonthFebruary:February`;
        break;
      }
      case 2: {
        monthString = $localize`:@@MonthMarch:March`;
        break;
      }
      case 3: {
        monthString = $localize`:@@MonthApril:April`;
        break;
      }
      case 4: {
        monthString = $localize`:@@MonthMay:May`;
        break;
      }
      case 5: {
        monthString = $localize`:@@MonthJune:June`;
        break;
      }
      case 6: {
        monthString = $localize`:@@MonthJuly:July`;
        break;
      }
      case 7: {
        monthString = $localize`:@@MonthAugust:August`;
        break;
      }
      case 8: {
        monthString = $localize`:@@MonthSeptember:September`;
        break;
      }
      case 9: {
        monthString = $localize`:@@MonthOctober:October`;
        break;
      }
      case 10: {
        monthString = $localize`:@@MonthNovember:November`;
        break;
      }
      case 11: {
        monthString = $localize`:@@MonthDecember:December`;
        break;
      }
      default: {
        throw new Error(`Invalid month passed to pipe: ${month}. Allowed: [0 .. 11]`);
      }
    }

    return monthString;
  }

}
